import { toastManager } from '@insurancemenu/imenu-components-lib/dist/components/Toast/toastManager';
import { ToastColorTypes } from '@insurancemenu/imenu-components-lib/dist/types';
import { getBenefitSummaryUploadUrl } from 'api/operations/productServiceV2';
import { uploadFiles } from 'global/utils/uploadFiles';
import { action, makeObservable, reaction, runInAction } from 'mobx';
import FileUploadDelegate from 'store/general/fileUploadDelegate';
import ModalDelegate from 'store/general/modalDelegate';

interface DomainParams {
  templateId: string;
  onUpload: () => Promise<void>;
}

export default class UploadDocumentModalDelegate extends ModalDelegate {
  public fileUploadDelegate: FileUploadDelegate = new FileUploadDelegate();
  private _domainParams: DomainParams;

  public uploadDocument = async (): Promise<void> => {
    this.setIsLoading(true);
    const uploadedFileName = this.fileUploadDelegate.uploadedFileNames[0];
    try {
      // Send file name and get url
      const res = await getBenefitSummaryUploadUrl(this._domainParams.templateId, uploadedFileName);
      await runInAction(async () => {
        await uploadFiles(this.fileUploadDelegate.uploadedFiles, { [uploadedFileName]: res }, async () => {
          toastManager.addToast('The document was successfully uploaded', ToastColorTypes.SUCCESS);
          await this._domainParams.onUpload();
        });
      });

      this.setIsLoading(false);
    } catch (error) {
      this.setIsLoading(false);
      toastManager.addToast(error as string, ToastColorTypes.WARNING);
    }
  };

  constructor(domainParams: DomainParams) {
    super();
    this._domainParams = domainParams;

    makeObservable(this, {
      uploadDocument: action.bound,
    });

    reaction(
      () => this.isVisible,
      (isVisible) => {
        runInAction(() => {
          this.fileUploadDelegate.setIsFileUploadReset(!isVisible);
        });
      },
    );
  }
}
